<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">品牌效果</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            @click="addSource()"
            class="btn-action"
            v-if="(oldInfos?.id && isRevise) || !isScore"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->
          <!-- <a-button @click="importsj(1)" class="btn-action" v-if="(oldInfos?.id && isRevise) || !isScore">
          导入
        </a-button> -->
          <a-button
            class="btn-action"
            danger
            type="text"
            @click="batchDelete"
            v-if="(oldInfos?.id && isRevise) || !isScore"
          >
            批量移除</a-button
          >
        </span>
      </div>
    </div>

    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template
          style="width: 100px"
          slot="capitalSource"
          slot-scope="text, record"
        >
          <tr
            v-for="(item, index) in record.lxSubsidyFundCostList"
            :key="index"
            :style="
              index + 1 == record.lxSubsidyFundCostList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.project">
              <span>{{ item.project }}</span>
            </div>
          </tr>
          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
        </template>
        <template style="width: 100px" slot="name" slot-scope="text, record">
          <tr
            v-for="(item, index) in record.lxSubsidyFundCostList"
            :key="index"
            :style="
              index + 1 == record.lxSubsidyFundCostList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.amount">
              <span>{{ item.amount }}</span>
            </div>
          </tr>
          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="text == '其他'">{{ record.otherType }}</span>
          <span v-else>{{ text }}</span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isEdit) || isScore"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record, index)"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="deleteInfo(record, index)"
            v-if="(oldInfos && oldInfos.id && isRevise) || !isScore"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="(oldInfos && oldInfos.id && !isRevise) || isScore"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
        <!-- <template
          slot="action"
          slot-scope="record"
          style="margin: 0 20px"
          v-if="oldInfos?.id"
        >
          <tr class="table-tr">
            <div
              class="table-content"
              style="
                justify-content: space-between;
                padding: 0px 50px;
                box-sizing: border-box;
              "
            >
              <div
                class="flex align-items-center"
                style="cursor: pointer"
                @click="editInfo(record, index)"
                v-if="oldInfos?.id && isRevise"
              >
                <img
                  class="img-box"
                  src="../../assets/images/img42.png"
                  alt=""
                />
                <span>编辑</span>
              </div>
              <div
                class="flex align-items-center"
                style="cursor: pointer"
                v-if="oldInfos?.id && isRevise"
                @click="deleteInfo(record, index)"
              >
                <img
                  class="img-box"
                  src="../../assets/images/img43.png"
                  alt=""
                />
                <span>移除</span>
              </div>
            </div>
          </tr>
        </template> -->
      </a-table>
    </div>
    <!-- 添加品牌效果 -->
    <AddEffect ref="foundSource" @addEffect="addGaincz"></AddEffect>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条品牌效果吗?</p>
    </a-modal>
    <data-import ref="dataImport" @refreshData="addGain"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          :dataid="sj.id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
import AddEffect from "./addEffect.vue";

const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "addYear",
    id: "addYear",
    align: "center",
    width: 100,
  },
  {
    title: "名称",
    dataIndex: "award",
    id: "award",
    align: "center",
    width: 150,
  },
  {
    title: "类别",
    dataIndex: "type",
    id: "type",
    align: "center",
    width: 100,
    scopedSlots: { customRender: "type" },
  },
  {
    title: "个数",
    dataIndex: "num",
    id: "num",
    align: "center",
    width: 150,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 350,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      yearShowOne: false,
      selectedRowKeys: [],
      isEdit: false,
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isScore: false,
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    AddEffect,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  watch: {
    "oldInfos.brandEffectlist": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.emptyText = "暂无数据";
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = !newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.addGain();
  },
  methods: {
    showevidence(record) {
      this.title = "品牌效果";
      this.id = this.oldInfos.id;
      this.showtable = true;
      this.sj = record;
    },
    importsj(num) {
      this.$refs.dataImport.init("brandEffect", this.oldInfos, "品牌效果");
    },
    addGain() {
      // this.pagination.current = 1;
      this.getData();
    },
    addSource() {
      console.log("addSource this.oldInfos", this.oldInfos);
      console.log("this.$refs.foundSource", this.$refs.foundSource);
      this.$refs.foundSource.init("add", this.oldInfos);
    },
    addPay() {
      this.$refs.foundPay.init("add", this.oldInfos);
    },
    seeInfo(row) {
      this.$refs.foundSource.init("see", row);
    },
    foundPay() {
      this.getData();
    },
    addGaincz(sj) {
      if (this.oldInfos?.id) {
        this.addGain();
      } else {
        // this.pagination.current = 1;
        if (sj.type == "add") {
          // sj.record.id = sj.record.num + this.oldInfos.brandEffectlist.length;
          // this.oldInfos.brandEffectlist.push(sj.record);
          this.pagination.current = 1;
          sj.record.id = sj.record.num + this.oldInfos.brandEffectlist.length;
          this.oldInfos.brandEffectlist.unshift({
            ...sj.record,
            id: sj.record.num + (this.oldInfos.brandEffectlist.length + 1),
          });
        } else {
          let index = this.oldInfos.brandEffectlist.findIndex(
            (item) => item.id === sj.record.id
          );
          // console.log(sj.record.id,this.oldInfos.brandEffectlist);
          if (index !== -1) {
            // 如果找到相同的 id，替换该对象
            this.oldInfos.brandEffectlist[index] = sj.record;
          }
        }
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/effect/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.brandEffectlist &&
          this.oldInfos.brandEffectlist.length > 0
        ) {
          this.pagination.total = this.oldInfos.brandEffectlist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          // this.dataList = this.oldInfos.brandEffectlist.slice(
          //   startIndex,
          //   endIndex
          // );
          let formatList = this.oldInfos.brandEffectlist.slice(
            startIndex,
            endIndex
          );
          if (formatList.length == 0 && this.pagination.current > 1) {
            this.pagination.current = this.pagination.current - 1;
            const startIndex =
              (this.pagination.current - 1) * this.pagination.pageSize;
            const endIndex = startIndex + this.pagination.pageSize;
            formatList = this.oldInfos.brandEffectlist.slice(
              startIndex,
              endIndex
            );
          }
          this.dataList = formatList;
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    handleOk() {
      if (this.oldInfos?.id) {
        deleteAction("/effect/delete", {
          id: this.deteleId,
          applyId: this.oldInfos?.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.success("移除成功");
        this.showDeleteModel = false;
        this.oldInfos.brandEffectlist = this.oldInfos.brandEffectlist.filter(
          (item) => item.id != this.deteleId
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    deleteInfo(row, index) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row, index) {
      this.$refs.foundSource.init("edit", row, index);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.year = ""; // 或者适当的空值，根据你的业务需求
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.form.joinYear = value;
      this.$refs.ruleForm.clearValidate("year");
      this.yearShowOne = false;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的预算");
      } else {
        if (this.oldInfos?.id) {
          let params = {
            ids: this.selectedRowKeys.toString(),
            applyId: this.oldInfos?.id,
          };
          deleteAction("/effect/deleteBatch", params).then((res) => {
            if (res.code == 200) {
              this.$message.success("批量移除成功");
              // this.pagination.current = 1;
              this.getData();
              this.selectedRowKeys = [];
              this.$forceUpdate();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          // this.pagination.current = 1;
          // console.log(this.selectedRowKeys);
          this.oldInfos.brandEffectlist = this.oldInfos.brandEffectlist.filter(
            (item) => !this.selectedRowKeys.includes(item.id)
          );
          sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
          this.getData();
          this.selectedRowKeys = [];
        }
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.cotainer {
  &.card-item {
    background: #ffffff;
    box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
    padding: 37px 20px;
    box-sizing: border-box;
    margin-bottom: 24px;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // margin-bottom: 12px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 700;
      border-bottom: 1px solid #d9d9d9;
      .title-text {
        color: #2155b5;
        font-size: 20px;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 3px solid #2155b5;
        padding: 0px 4px;
      }
    }
  }
  .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #2155b5;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}
.big-box {
  width: 253px;
  margin: 50px auto 0px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-content {
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(5),
/deep/.ant-table-tbody > tr > td:nth-child(4) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
/deep/.ant-table-tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.table-content {
  margin: 0 auto;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(6),
/deep/.ant-table-tbody > tr > td:nth-child(5) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>
